<template>
  <div>
    <h1>訂閱項目</h1><!--目前所在頁面標題-->

    <section class="normalList">
      <div class="remind_text">
        <img src="@/assets/images/icon_info_filled.svg" alt="remind_icon" class="remind_icon">
        如欲管理訂閱內容，請在一刻鯨選App中的「設定／訂閱項目」中進行操作
      </div>
      <ul class="sub_list">
        <li class="sub_list_item" v-for="subscription in sortSubscriptionData" :key="subscription.id">
          <SubscriptionCard :subscription="subscription"/>
        </li>
      </ul>
    </section>

    <section class="emptyPage"  v-if="subscriptionData.length == 0">
      <div class="wrap">
        <figure>
          <img src="@/assets/images/status_empty_cart.png" alt="尚未購買課程">
          <figcaption>
            尚未訂閱任何專區喔
          </figcaption>
        </figure>
      </div>
    </section>

  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import SubscriptionCard from './components/SubscriptionCard'

export default {
  name: 'subscription',
  metaInfo () {
    return {
      title: '訂閱項目 | 我的 | 一刻鯨選',
      meta: [
        // OpenGraph data (Most widely used)
        { property: 'og:title', content: '訂閱項目 | 我的 | 一刻鯨選' },
        { property: 'og:site_name', content: '訂閱項目 | 我的 | 一刻鯨選' },
        // The list of types is available here: http://ogp.me/#types
        { property: 'og:type', content: 'website' },
        // Should the the same as your canonical link, see below.
        { property: 'og:url', content: window.location.toString() },
        { property: 'og:image', content: this.$store.state.urlDomain + '/static/logo.jpg' },
        // Often the same as your meta description, but not always.
        { property: 'og:description', content: '登入後，即可查看帳戶所有資訊。' }

      ]
    }
  },
  components: { SubscriptionCard },
  data () {
    return {
      subscriptionData: []

      // 測試資料 START
      // addSubscriptionData: [
      //   {
      //     id: "1",
      //     isExpired: true,
      //     area: {
      //       id: 0,
      //       display_name: "去聽小說",
      //       imgCover: "https://test.jinfm.net/images/channels/68/cover.jpg"
      //     },
      //     subscription_type: 0,
      //     autoRenew: 0,
      //     startServiceTime: "2020-10-10T04:16:35Z",
      //     lastServiceTime: "2020-12-01T04:16:35Z",
      //     retreatStatus: "string",
      //     created_at:  "2020-06-10T04:16:35Z"
      //   },
      //   {
      //     id: "2",
      //     isExpired: false,
      //     area: {
      //       id: 0,
      //       display_name: "精選課程精選課程精選課程精選課程精選課程",
      //       imgCover: "https://test.jinfm.net/images/channels/60/cover.jpg"
      //     },
      //     subscription_type: 0,
      //     autoRenew: 0,
      //     startServiceTime: "2020-06-15T04:16:35Z",
      //     lastServiceTime: "2021-01-31T04:16:35Z",
      //     retreatStatus: "string",
      //     created_at:  "2020-06-25T04:16:35Z"
      //   },
      //   {
      //     id: "77",
      //     isExpired: true,
      //     area: {
      //       id: 0,
      //       display_name: "去聽小說",
      //       imgCover: "https://test.jinfm.net/images/channels/68/cover.jpg"
      //     },
      //     subscription_type: 0,
      //     autoRenew: 0,
      //     startServiceTime: "2020-10-10T04:16:35Z",
      //     lastServiceTime: "2020-12-01T04:16:35Z",
      //     retreatStatus: "string",
      //     created_at:  "2020-06-01T04:16:35Z"
      //   },
      //   {
      //     id: "3",
      //     isExpired: false,
      //     area: {
      //       id: 0,
      //       display_name: "精選課程",
      //       imgCover: "https://test.jinfm.net/images/channels/60/cover.jpg"
      //     },
      //     subscription_type: 0,
      //     autoRenew: 0,
      //     startServiceTime: "2020-06-15T04:16:35Z",
      //     lastServiceTime: "2021-01-31T04:16:35Z",
      //     retreatStatus: "string",
      //     created_at:  "2020-06-12T04:16:35Z"
      //   }
      // ]
      // 測試資料 END
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    sortSubscriptionData () {
      const trueArr = []
      const falseArr = []
      const data = this.subscriptionData

      const dateToTime = function (str) {
        return new Date(str).getTime() // 用/替換日期中的-是為了解決Safari的相容
      }

      for (var i = 0; i < data.length; i++) {
        data[i].publishTimeNew = dateToTime(data[i].created_at)
        if (data[i].isExpired === true) {
          trueArr.push(data[i])
        } else {
          falseArr.push(data[i])
        }
      }

      trueArr.sort(function (a, b) {
        return b.publishTimeNew > a.publishTimeNew ? -1 : 1
      })
      falseArr.sort(function (a, b) {
        return b.publishTimeNew > a.publishTimeNew ? -1 : 1
      })

      return [...falseArr, ...trueArr]
    }
  },
  created () {
    this.axios
      .get(this.$store.getters.baseURL + 'properties/subscription', { headers: { Authorization: `Bearer ${localStorage.getItem('credentialToken')}` } })
      .then(response => {
        // console.log(response.data)
        this.subscriptionData = response.data
      })
      .catch(error => console.log('log:' + error))
  },
  methods: {

  }

}
</script>

<style lang="scss" scoped>

// @import '../../../../assets/css/user.css';
// @import '../../../../assets/css/user_rwd.css';
 body {padding-top: 0;}
 /* body {padding-top: 0;}
 .bodyHeader {display: none;} */

 .remind_text {
   font-size: 14px;
   display: flex;
   margin-top: 20px;
   .remind_icon {
      width: 16px;
      align-self: flex-start;
      margin-top: 4px;
      margin-right: 11px;
   }
 }

 .sub_list {
    margin-top: 22px;
    .sub_list_item {
      position: relative;
      width: 100%;
      background-color: rgba(23, 110, 141, 0.05);
      border-radius: 20px;
      padding: 24px;
      margin-bottom: 20px;
      .sub_content {
        margin-bottom: 50px;
      }
      .sub_title {
        font-size: 22px;
        line-height: 31px;
        font-weight: 600;
        margin-bottom: 10px;
        padding-top: 0;
      }
      .sub_status {
        font-size: 14px;
        line-height: 20px;
        font-weight: 600;
        color: rgb(246,140,4);
        .sub_icon {
          width: 14px;
          margin-right: 6px;
        }
      }
      .sub_time {
        font-size: 14px;
        line-height: 20px;
        color: rgba(0,0,0,0.5);
      }
      .sub_img {
        flex: 0 0 120px;
        width: 120px;
      }
    }
    @media screen and (min-width: 992px) {
      justify-content: space-between;
      .sub_list_item {
        width: 48%;
        margin-bottom: 30px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/views/mySubviews/MySubscription/index.vue